import { render } from "./Top.vue?vue&type=template&id=098f34bb&scoped=true"
import script from "./Top.vue?vue&type=script&lang=js"
export * from "./Top.vue?vue&type=script&lang=js"

import "./Top.vue?vue&type=style&index=0&id=098f34bb&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-098f34bb"]])

export default __exports__